import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ReactiveFormsModule } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AppModalService } from './modal.service';

import { ButtonModule } from '../button/button.module';
import { FormModule } from '../form/form.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { AppTooltipModule } from '../tooltip/tooltip.module';
import { ScrollModule } from '../scroll/scroll.module';
import { SpinnerModule } from '../spinner/spinner.module';
import { IconModule } from '../icon/icon.module';
import { PipesModule } from '../pipes/pipes.module';
import { EmptyStateModule } from '../empty-state/empty-state.module';
import { LoaderModule } from '../loader/loader.module';
import { SearchModule } from '../search/search.module';
import { OnlyIntegerNumberModule } from '../only-integer-number/only-integer-number.module';

import { ModalLayoutComponent } from './modal-layout/modal-layout.component';
import { DefaultModalComponent } from './default-modal/default-modal.component';
import { CreateNewProductModalComponent } from './create-new-product-modal/create-new-product-modal.component';
import { CreateProductCopyModalComponent } from './create-product-copy-modal/create-product-copy-modal.component';
import { ProductCopyOptionsComponent } from 'shared/modal/create-product-copy-modal/product-copy-options/product-copy-options.component';
import {
  CurrentProductsSearchComponent
} from 'shared/modal/create-product-copy-modal/current-products-search/current-products-search.component';
import {
  PartNumberInputModalComponent
} from 'shared/modal/create-product-copy-modal/part-number-input-modal/part-number-input-modal.component';
import { DeleteModalComponent } from './delete-modal/delete-modal.component';
import { SaveBeforeLeavingComponent } from './save-before-leaving/save-before-leaving.component';
import { PanelModalComponent } from './panel-modal/panel-modal.component';
import { PanelModalHeaderComponent } from './panel-modal/panel-modal-header/panel-modal-header.component';
import { ErrorModalComponent } from './error-modal/error-modal.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { ConfirmBulkEditsModalComponent } from './confirm-bulk-edits-modal/confirm-bulk-edits-modal.component';
import { ProfileResetPasswordModalComponent } from '../profile/profile-reset-password-modal/profile-reset-password-modal.component';
import { ProfilePasswordFormComponent } from '../profile/profile-password-form/profile-password-form.component';
import { ProfileInputComponent } from '../profile/profile-input/profile-input.component';
import { BrandChooseModalComponent } from '../brand/brand-choose-modal/brand-choose-modal.component';
import { ModalInfoRowComponent } from './modal-info-row/modal-info-row.component';
import { VersionModalComponent } from 'shared/modal/version-modal/version-modal.component';

import { AddEditUserModalComponent } from '../team/add-edit-user-modal/add-edit-user-modal.component';
import { AddEditUserFormComponent } from '../team/add-edit-user-modal/add-edit-user-form/add-edit-user-form.component';
import { ManageBillingModalComponent } from './manage-billing-modal/manage-billing-modal.component';
import { ManageBillingFormComponent } from './manage-billing-modal/manage-billing-form/manage-billing-form.component';
import { SendBillingModalComponent } from './send-billing-modal/send-billing-modal.component';
import { SendBillingFormComponent } from './send-billing-modal/send-billing-form/send-billing-form.component';
import { ChangePlanModalComponent } from './change-plan-modal/change-plan-modal.component';
import { PlanComponent } from './change-plan-modal/plan/plan.component';
import { WarningModalComponent } from './warning-modal/warning-modal.component';
import { SimpleTableModalComponent } from './simple-table-modal/simple-table-modal.component';
import { SimpleConfirmModalComponent } from './simple-confirm-modal/simple-confirm-modal.component';
import { FitmentDuplicateModalComponent } from './fitment-duplicate-modal/fitment-duplicate-modal.component';
import { ModalHeaderSearchComponent } from './modal-header-search/modal-header-search.component';
import { ModalActionPanelComponent } from './modal-action-panel/modal-action-panel.component';
import { TermsModalComponent } from './terms/terms-modal/terms-modal.component';
import { PaymentTermsModalComponent } from './payment-terms/payment-terms-modal.component';
import { TakeOverModalComponent } from './terms/take-over-modal/take-over-modal.component';
import { PlanWarningModalComponent } from './plan-warning-modal/plan-warning-modal.component';
import { BillingInfoModalComponent } from './billing-info-modal/billing-info-modal.component';
import { BaseModalComponent } from './_base-modal.component';
import { ModalV2Component } from './modal-v2/modal-v2.component';
import { FinalModalComponent } from './final-modal/final-modal.component';
import { ProcessingModalComponent } from './processing-modal/processing-modal.component';
import { ChangeStatusesModalComponent } from './change-statuses-modal/change-statuses-modal.component';
import { ExportDownloadsModalComponent } from './export-downloads-modal/export-downloads-modal.component';
import { ExportDownloadsTableComponent } from './export-downloads-modal/export-downloads-table/export-downloads-table.component';
import { FittextModule } from 'shared/fittext/fittext.module';
import { PaginationModule } from 'shared/pagination/pagination.module';


@NgModule({
    imports: [
        ButtonModule,
        CommonModule,
        FormModule,
        DropdownModule,
        ScrollModule,
        ModalModule.forRoot(),
        ReactiveFormsModule,
        FormsModule,
        LoaderModule,
        AppTooltipModule,
        SpinnerModule,
        IconModule,
        SearchModule,
        PipesModule,
        OnlyIntegerNumberModule,
        NgxMaskDirective,
        NgxMaskPipe,
        FittextModule,
        EmptyStateModule,
        PaginationModule,
    ],
    declarations: [
        ModalLayoutComponent,
        DefaultModalComponent,
        SaveBeforeLeavingComponent,
        CreateNewProductModalComponent,
        CreateProductCopyModalComponent,
        ProductCopyOptionsComponent,
        CurrentProductsSearchComponent,
        PartNumberInputModalComponent,
        DeleteModalComponent,
        PanelModalComponent,
        PanelModalHeaderComponent,
        ErrorModalComponent,
        InfoModalComponent,
        ConfirmBulkEditsModalComponent,
        ProfileResetPasswordModalComponent,
        BrandChooseModalComponent,
        AddEditUserModalComponent,
        AddEditUserFormComponent,
        ManageBillingModalComponent,
        ManageBillingFormComponent,
        SendBillingModalComponent,
        SendBillingFormComponent,
        ChangePlanModalComponent,
        PlanComponent,
        ProfilePasswordFormComponent,
        ProfileInputComponent,
        WarningModalComponent,
        SimpleTableModalComponent,
        SimpleConfirmModalComponent,
        FitmentDuplicateModalComponent,
        ModalHeaderSearchComponent,
        ModalActionPanelComponent,
        TermsModalComponent,
        PaymentTermsModalComponent,
        TakeOverModalComponent,
        PlanWarningModalComponent,
        BillingInfoModalComponent,
        BaseModalComponent,
        ModalV2Component,
        FinalModalComponent,
        ProcessingModalComponent,
        ChangeStatusesModalComponent,
        ExportDownloadsModalComponent,
        ExportDownloadsTableComponent,
        ModalInfoRowComponent,
        VersionModalComponent,
    ],
    exports: [
        ModalLayoutComponent,
        DefaultModalComponent,
        SaveBeforeLeavingComponent,
        CreateNewProductModalComponent,
        CreateProductCopyModalComponent,
        ProductCopyOptionsComponent,
        CurrentProductsSearchComponent,
        PartNumberInputModalComponent,
        DeleteModalComponent,
        PanelModalComponent,
        PanelModalHeaderComponent,
        ErrorModalComponent,
        InfoModalComponent,
        ConfirmBulkEditsModalComponent,
        ProfileResetPasswordModalComponent,
        BrandChooseModalComponent,
        AddEditUserModalComponent,
        ManageBillingModalComponent,
        SendBillingModalComponent,
        ChangePlanModalComponent,
        ProfilePasswordFormComponent,
        ProfileInputComponent,
        WarningModalComponent,
        SimpleTableModalComponent,
        SimpleConfirmModalComponent,
        FitmentDuplicateModalComponent,
        ModalHeaderSearchComponent,
        ModalActionPanelComponent,
        TermsModalComponent,
        PaymentTermsModalComponent,
        TakeOverModalComponent,
        PlanWarningModalComponent,
        BillingInfoModalComponent,
        BaseModalComponent,
        ModalV2Component,
        FinalModalComponent,
        ProcessingModalComponent,
        ChangeStatusesModalComponent,
        ExportDownloadsModalComponent,
        ModalInfoRowComponent,
        VersionModalComponent,
    ],
    providers: [AppModalService, provideNgxMask()]
})
export class AppModalModule { }
